import { IonSearchbar, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { chevronForwardOutline, heart } from 'ionicons/icons';
import { ContentInfo, ContentUpdateInt } from '../data/item';
import React, { useState }  from 'react';

import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

  
const SearchBarContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate }) => {
    
    const [searchText, setSearchText] = useState("");

    const router = useIonRouter();

    // click on love icon
    const onLike = () => {
        router.push("/token/wallet", "forward", "push");
    }

    // alert to search
    const alertSearch = (val : string) => {
        content.desc = val;
        onUpdate(index, content, true);
    }

    return (
        <div className="title-content">
            <IonToolbar className="content-wrapper">
                <IonSearchbar className="search-bubble" slot="start" placeholder={ GetStr(LANGUAGE.TXT_SEARCH) } value={searchText} onIonChange={e => alertSearch(e.detail.value!)}></IonSearchbar>
                <IonChip slot="end" onClick={onLike}>
                    <IonIcon icon={heart} color="primary" size="large"></IonIcon>
                    <IonLabel>{ content.user_name }</IonLabel>
                </IonChip>
            </IonToolbar>
        </div>
    );
};
  
export default SearchBarContent;